import { DocumentSmartTextInspectorAction } from "./documentSmartTextInspectorActions";
import {
  CLOSE_INSPECTOR,
  DocumentSmartTextInspectorState,
  OPEN_CREATE,
  OPEN_INSPECTOR
} from "./documentSmartTextInspectorTypes";

export const initialState: DocumentSmartTextInspectorState = {
  activeFieldId: null,
  draftId: null,
  anchorRect: null,
  mode: null
};

const documentSmartTextInspectorReducers = (
  state: DocumentSmartTextInspectorState = initialState,
  action: DocumentSmartTextInspectorAction
): DocumentSmartTextInspectorState => {
  switch (action.type) {
    case OPEN_INSPECTOR:
      return {
        activeFieldId: action.payload.fieldId,
        draftId: null,
        anchorRect: action.payload.anchorRect,
        mode: "inspector"
      };
    case OPEN_CREATE:
      return {
        activeFieldId: null,
        draftId: action.payload.draftId,
        anchorRect: action.payload.anchorRect,
        mode: "create"
      };
    case CLOSE_INSPECTOR:
      return initialState;
    default:
      return state;
  }
};

export default documentSmartTextInspectorReducers;
